<template>
  <BaseField
    ref="field"
    v-bind="attributes"
    v-on="$listeners"
    @focus="onFieldFocus"
    @blur="onFieldBlur"
  />
</template>

<script>
import BaseField from '@/components/BaseField.vue';

export default {
  name: 'FieldEmail',
  components: {
    BaseField,
  },
  staticData: () => ({
    currentLocale: '',
  }),
  computed: {
    attributes() {
      return {
        type: 'email',
        placeholder: this.$t('fields.email'),
        errorMessage: this.$t('fields.badEmail'),
        checkIsComplete: (value) => /^.+@.+\..+$/.test(value),
        required: true,
        ...this.$attrs,
      };
    },
  },
  methods: {
    checkValidity() {
      return this.$refs.field?.checkValidity();
    },
    focus() {
      return this.$refs.field?.focus();
    },
    // При фокусе сохраняем текущий язык и переключаем на en
    async onFieldFocus() {
      try {
        this.currentLocale = await this.$robot.keyboardService.getLocale();
        await this.$robot.keyboardService.setLocale('en_US');
      } catch (e) {
        console.error(e);
      }
    },
    // При блуре возвращаем язык сохраненный перед фокусом
    async onFieldBlur() {
      try {
        await this.$robot.keyboardService.setLocale(this.currentLocale);
      } catch (e) {
        console.error(e);
      }
    },
  },
};
</script>
